import { ApiError, type ApiErrorBody } from '../api/client';

export function messageFromApiBody(body: ApiErrorBody, status: number): string {
  if (body.error?.message) {
    return body.error.message;
  }
  if (Array.isArray(body.detail)) {
    return body.detail
      .map((item) => {
        const field = item.loc?.filter((p) => p !== 'body').pop() ?? 'field';
        return `${String(field)}: ${item.msg}`;
      })
      .join(' · ');
  }
  if (typeof body.detail === 'string') {
    return body.detail;
  }
  return `Request failed (${status})`;
}

export function formatError(err: unknown): string {
  if (err instanceof ApiError) {
    return err.message;
  }
  if (err instanceof Error) {
    return err.message;
  }
  if (typeof err === 'string') {
    return err;
  }
  try {
    return JSON.stringify(err);
  } catch {
    return 'Something went wrong';
  }
}
